export var STRATEGY_POST_HYDRATE = 'post-hydrate';
export var STRATEGY_IDLE = 'idle';
export var STRATEGY_OFF_MAIN_THREAD = 'off-main-thread';
export var STRATEGY_AFTER_USER_INTERACTION = 'after-user-interaction';
export var DEFAULT_SCRIPT_LOAD_STRATEGY = STRATEGY_POST_HYDRATE;
export var HANDLED_PROPS = new Set(['id', 'src', 'strategy', 'dangerouslySetInnerHTML', 'children', 'onLoad', 'onError', 'targetSelector']);
export var ID_NAMESPACE = '478ae2b6-075a-5fb0-991c-be48f6a39994';
export var DEFAULT_TARGET_SELECTOR = 'head';